import ChevronRight from "@/assets/icons/24/ChevronRight";
import { Check as CheckIcon } from "@/assets/icons/24/line/Check";
import CrossIcon from "@/assets/icons/24/line/Cross";

type PasswordStrengthEntryIconProps = {
  state?: "default" | "valid" | "invalid";
};

export const PasswordStrengthEntryIcon = ({
  state,
}: PasswordStrengthEntryIconProps) => {
  if (state === "valid") {
    return <CheckIcon className="h-4 w-4 text-brand-500" />;
  }

  if (state === "invalid") {
    return <CrossIcon className="h-4 w-4 text-attention-500" />;
  }

  return <ChevronRight className="h-4 w-4 text-grey-500" />;
};
